import { render } from "./TableMetric.vue?vue&type=template&id=38cfb708"
import script from "./TableMetric.vue?vue&type=script&lang=js"
export * from "./TableMetric.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nekenaratafitaharitsimba/Work/HULSIA/PROJECTS/smilemood-v2/smilemood-v2-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TableMetric.vue"]])

export default __exports__